import React from 'react';

/**
 * Shared empty-state placeholder used across all lists and tables.
 *
 * Props:
 *   icon       - Lucide icon element (required)
 *   title      - heading text (required)
 *   description - secondary helper text (optional)
 *   action     - JSX button/CTA below description (optional)
 *   iconBg     - CSS gradient string for the icon circle bg (optional)
 *   style      - extra style for the outer wrapper (optional)
 */
const EmptyState = ({ icon, title, description, action, iconBg, style = {} }) => {
    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '64px 24px',
            textAlign: 'center',
            ...style,
        }}>
            <div style={{
                width: 64,
                height: 64,
                borderRadius: 20,
                background: iconBg || 'linear-gradient(135deg, #eef2ff, #e0e7ff)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginBottom: 20,
            }}>
                {icon}
            </div>
            <div style={{ fontWeight: 600, fontSize: 16, color: '#1e293b', marginBottom: description ? 8 : 0 }}>
                {title}
            </div>
            {description && (
                <div style={{
                    fontSize: 14,
                    color: '#94a3b8',
                    maxWidth: 360,
                    lineHeight: 1.6,
                    marginBottom: action ? 24 : 0,
                }}>
                    {description}
                </div>
            )}
            {action && action}
        </div>
    );
};

export default EmptyState;
